import { render, staticRenderFns } from "./DescriptionFormComponent.vue?vue&type=template&id=1b8a7788&xmlns=true&"
import script from "./DescriptionFormComponent.vue?vue&type=script&lang=js&"
export * from "./DescriptionFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports